export const SEPARATORS = {
    Dot: '.',
    Dash: '-',
} as const;

interface ISeparators {
    /** Текущий разделитель между числами */
    currentSeparator: string;
    /** Разделитель на который меняем */
    separator: string;
}

export type TDirectionSendData = 'toClient' | 'toServer';
type TMapConfigSeparatorForDate = Record<TDirectionSendData, ISeparators>;

export const mapConfigSeparatorForDate: TMapConfigSeparatorForDate = {
    toClient: { currentSeparator: SEPARATORS.Dash, separator: SEPARATORS.Dot },
    toServer: { currentSeparator: SEPARATORS.Dot, separator: SEPARATORS.Dash },
};
